<template>
  <div class="" style="width: 150px; color: white; margin-bottom: 20px; margin-top: 5%; margin-left: 5%;">
    <Button type="transparent" :text="$t('button.back')" link="projects" target="_self" />
  </div>
  
  <div class="_container" v-if="!loading">
    <div class="_insideContainer">
      <div class="_title">
        <div class="_subTitle"></div>
        <div class="_subTitle1">{{ projectData.detailTitle || projectData.title }}</div>
        <div class="aims">{{ projectData.detailDesc }}</div>
      </div>
      
      <div class="infoContainer">
        
        <div class="leftContainer">
          <div class="imgContainerMobile">
            <!-- MOBİL İÇİN: Görsel varsa veritabanındakini, yoksa varsayılanı göster -->
            <img v-if="projectData.imageUrl" :src="projectData.imageUrl" alt="Proje Görseli" />
            <img v-else src="@/assets/images/coSpectro.png" alt="Varsayılan Görsel" />
          </div>
          <div class="info-ul">
            <li v-for="(feature, index) in leftFeatures" :key="'left-' + index" data-aos="fade-down" :data-aos-delay="300 + (index * 100)" data-aos-offset="500px">
              <div class="dot">{{ index + 1 }}</div>
              <h4>{{ feature }}</h4>
            </li>
          </div>
        </div>
        
        <div class="imgContainer">
          <!-- MASAÜSTÜ İÇİN: Görsel varsa veritabanındakini, yoksa varsayılanı göster -->
          <img v-if="projectData.imageUrl" :src="projectData.imageUrl" alt="Proje Görseli" />
          <img v-else src="@/assets/images/coSpectro.png" alt="Varsayılan Görsel" />
        </div>

        <div class="rightContainer">
          <div class="info-ul">
            <li v-for="(feature, index) in rightFeatures" :key="'right-' + index" data-aos="fade-down" :data-aos-delay="700 + (index * 100)" data-aos-offset="500px">
              <div class="dot">{{ leftFeatures.length + index + 1 }}</div>
              <h4>{{ feature }}</h4>
            </li>
          </div>
        </div>
        
      </div>
    </div>
  </div>
  
  <div v-else class="_container" style="min-height: 50vh;">
    <h3 style="color: white;">Proje Detayları Yükleniyor...</h3>
  </div>
</template>

<script>
import Button from "../common/Button.vue";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { initializeApp, getApps, getApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyBxpNV_8UazGQ3pMReWWIdROn7AZlMT17Y",
  authDomain: "baumind-45d99.firebaseapp.com",
  projectId: "baumind-45d99",
  storageBucket: "baumind-45d99.firebasestorage.app",
  messagingSenderId: "982282716223",
  appId: "1:982282716223:web:25ebcf827c8e87c555248a",
  measurementId: "G-FDZLC80DZ2"
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const db = getFirestore(app);

export default {
  name: "ProjectSpectrum",
  components: { Button },
  data() {
    return {
      projectData: {},
      leftFeatures: [],
      rightFeatures: [],
      loading: true,
    };
  },
  async mounted() {
    const routeId = this.$route.params.id; 
    if (!routeId) { this.loading = false; return; }

    try {
      const querySnapshot = await getDocs(collection(db, "projeler"));
      let matchedDoc = null;

      querySnapshot.forEach((docSnap) => {
        if (docSnap.id.toLowerCase() === routeId.toLowerCase()) { matchedDoc = docSnap; }
      });

      if (matchedDoc && matchedDoc.exists()) {
        const data = matchedDoc.data();
        this.projectData = data;
        if (data.techSpecs) {
          const lines = data.techSpecs.split('\n').filter(l => l.trim() !== '');
          const mid = Math.ceil(lines.length / 2);
          this.leftFeatures = lines.slice(0, mid);
          this.rightFeatures = lines.slice(mid);
        }
      } else {
        console.error("Proje bulunamadı!");
      }
    } catch (error) {
      console.error("Proje detayları çekilirken hata:", error);
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style scoped>
._container { background-color: #121619; width: 100%; font-family: "DM Sans", sans-serif; color: aliceblue; padding: 0 5% 5% 5%; display: flex; flex-direction: column; align-items: center; justify-content: center; }
._insideContainer { max-width: 1900px; width: 100%; }
._title { width: 100%; display: flex; flex-direction: column; padding-bottom: 20px; align-items: center; }
._subTitle1 { display: flex; justify-content: center; text-align: center; font-size: 25px; color: rgb(229, 236, 243); }
.aims { color: rgb(169, 167, 167); text-align: center; width: 100%; max-width: 600px; font-size: 15px; line-height: 1.4; padding-top: 15px; }
.infoContainer { display: flex; flex-direction: row; justify-content: center; padding-top: 5%; max-width: 1900px; }
.leftContainer, .rightContainer { display: flex; flex-direction: column; }
h4 { color: rgb(229, 236, 243); font-family: "DM Sans", sans-serif; margin: 0; font-size: 20px; }
.imgContainer { display: flex; flex-direction: row; justify-content: center; padding: 0 20px; }
.imgContainer img { width: 100%; max-width: 350px; object-fit: contain; }
.imgContainerMobile { display: none; }
.info-ul { display: flex; flex-direction: column; justify-content: start; list-style: none; padding: 0; }
.info-ul li { display: flex; align-items: center; padding-bottom: 30px; }
.dot { display: flex; justify-content: center; align-items: center; border: 1px solid rgb(229, 236, 243); border-radius: 100px; min-width: 20px; min-height: 20px; margin-right: 10px; font-size: 12px; color: rgb(229, 236, 243); background-color: #121619; }

@media screen and (max-width: 1023px) {
  ._insideContainer { flex-direction: column; }
  .infoContainer { flex-direction: column; padding-top: 40px; }
  ._title { padding-top: 40px; }
  .info-ul li h4 { font-size: 17px; }
  .info-ul li { padding-bottom: 0px; margin-bottom: 20px; }
  .imgContainer { display: none; }
  .imgContainerMobile { display: flex; flex-direction: row; justify-content: center; margin-bottom: 20px; }
  .imgContainerMobile img { width: 100%; max-width: 300px; object-fit: contain; }
}
</style>